'use client';

import useSimpleApiHandler from '@frontend/jetlend-core/src/hooks/useSimpleApiHandler';
import React from 'react';
import { useScroll } from '@frontend/jetlend-web-ui/src/hooks/useScroll';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import Link from 'next/link';
import { accountInfoHandler } from '@app/ducks/common/account';

import styles from './topLoginPlate.module.scss';

/**
 * Компонент для отрисовки плашки с предложением войти в ЛК
 */
const TopLoginPlate = () => {
    const isScrolled = useScroll();
    const [account, isFetching] = useSimpleApiHandler(accountInfoHandler);
    const isUserLogin = account && account?.user_id;

    const containerClassName = buildClassNames(styles, [
        'login-block',
        isScrolled && 'login-block--scrolled',
    ]);

    const fixedContainerClassName = buildClassNames(styles, [
        'login-block',
        'login-block--fixed',
        isScrolled && 'login-block--scrolled',
    ]);

    if (isFetching) {
        return null;
    }

    return (isUserLogin
        ? null
        : (
            <>
                <div className={fixedContainerClassName}>
                    <Link href="/invest/login/?return_uri=/academy">Войти</Link>
                    &nbsp;
                    для сохранения текущего прогресса
                </div>
                <div className={containerClassName} />
            </>
        )
    );
};

export default TopLoginPlate;